export const MAX_ICON_SIZE = 174;
export const MAX_LOGO_WIDTH = 160;
export const MAX_LOGO_HEIGHT = 50;
